<template>
  <div></div>
</template>

<script>
export default {
  name: 'SubscribeManagerToProgram',
};
</script>
